// Shared by the form and Edge Function so offline suggestions agree with AI ranking.
export function isPhoneListing(title: string): boolean {
  const text = title.toLowerCase().replace(/ё/g, "е");
  const phone = /iphone|айфон|смартфон|телефон(?:ы|ов|а)?(?=$|[^а-я])|samsung\s+galaxy\s+(?:[aszmf]\s*\d|note)|google\s+pixel|redmi|poco\s+[cfxm]\s*\d/.test(text);
  const accessoryOrService = /чех|кабел|заряд|адаптер|держател|защитн|стекло\s+для|пленк|дисплей\s+для|экран\s+для|аккумулятор\s+для|батарея\s+для|запчаст|корпус\s+для|крышк|ремонт|замен|наушник|гарнитур|case|cover|cable|charger|repair|protector/.test(text);
  return phone && !accessoryOrService;
}

export function phoneCategory<T extends { id: number; slug: string }>(title: string, categories: T[]): T | null {
  return isPhoneListing(title) ? categories.find((category) => category.slug === "phones") ?? null : null;
}
